import { useEffect } from 'react'

import { isInsideAgentFrame } from '../components/widget/agentFrameMarker'
import { COMPACT_IDLE_TIMEOUT_MS } from '../components/widget/agentWidgetLayout'

/**
 * compact の無操作時に入口へ戻す。編集中に閉じないよう、フォーカスが内側にある間は待ち直し、
 * 下書きがある間は呼び出し側が無効化する。枠内のキー入力とポインター移動で待ち時間をリセットする。
 * onTimeout が変わると待ち直すため、呼び出し側は同じ関数を渡す。
 */
export const useCompactIdleTimeout = (enabled: boolean, onTimeout: () => void): void => {
  useEffect(() => {
    if (!enabled) {
      return
    }
    let timer: ReturnType<typeof setTimeout> | undefined = undefined
    const restart = (): void => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (isInsideAgentFrame(document.activeElement)) {
          restart()
          return
        }
        onTimeout()
      }, COMPACT_IDLE_TIMEOUT_MS)
    }
    const handleActivity = (event: Event): void => {
      if (isInsideAgentFrame(event.target)) {
        restart()
      }
    }

    restart()
    document.addEventListener('pointermove', handleActivity)
    document.addEventListener('keydown', handleActivity)
    return (): void => {
      clearTimeout(timer)
      document.removeEventListener('pointermove', handleActivity)
      document.removeEventListener('keydown', handleActivity)
    }
  }, [enabled, onTimeout])
}
